// src/app/dashboard/dashboard-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { SubscriptionGuard } from '../core/guards/subscription.guard';
import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'main',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule)
      },
      {
        path: 'plan',
        loadChildren: () => import('./modules/plan/plan.module').then(m => m.PlanModule)
      },
      {
        path: 'drivers',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/drivers/drivers.module').then(m => m.DriversModule)
      },
      {
        path: 'vehicles',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'transactions',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/transactions/transactions.module').then(m => m.TransactionsModule)
      },
      {
        path: 'reports',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'benefits',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/benefits/benefits.module').then(m => m.BenefitsModule)
      },
      {
        path: 'salud',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/salud/salud.module').then(m => m.SaludModule)
      },
      {
        path: 'scheduling',
        canActivate: [SubscriptionGuard],
        loadChildren: () => import('./modules/scheduling/scheduling.module').then(m => m.SchedulingModule)
      },
      {
        path: 'repuestos',
        loadChildren: () => import('./modules/repuestos/repuestos.module').then(m => m.RepuestosModule)
      },
      {
        path: 'bienvenida',
        loadChildren: () => import('./modules/bienvenida/bienvenida.module').then(m => m.BienvenidaModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
